module.exports = __webpack_public_path__ + "dc3c0a8d3822f9414b2f6afc84139664.png";